import {
    STMarkerStyleDmlC,
    STRadarStyle,
    SubChartType,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import { PresetChartType } from '../chart-presets/const';
import type { IRadarChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

export class RadarChart extends BaseSubChart implements IRadarChart {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData): void {
        this.convertSubChartUiToSdkByType(SubChartType.RadarChart, uiData, sdkData, rawUiData);
    }

    public type = SubChartType.RadarChart;
    public radarStyle: STRadarStyle;

    public getPresetChartType(): PresetChartType {
        const hasMarker = this.series.some(seriesItem => seriesItem.marker
            && seriesItem.marker.symbol !== STMarkerStyleDmlC.none);
        if (hasMarker) return PresetChartType.RADAR_WITH_POINT;
        switch (this.radarStyle) {
            case STRadarStyle.filled:
                return PresetChartType.RADAR_WITH_FILL;
            default:
                return PresetChartType.RADAR;
        }
    }
}

